export const REPORT_PATHS = {
  ROOT: '/reports',
  SALES: '/reports/v2/sales',
  PAYMENTS: '/reports/v2/payments',
  PRODUCTS: '/reports/v2/products',
  CANCELLATION: '/reports/v2/cancellation',
} as const;
